export const themeLight = {
	colors: {
		white: '#ffffff',
		borderNav: '#E0E5EB',
		googleBtn: '#F5F7FA',
		body: '#F6F7FB',
		textMain: '#242A37',
		textSecondary: '#898F9F',
		black: '#000000',
		icons: '#A6ABB9',
		bookIcons: '#6D7A8D',

		myTrainingBox: '#B1B5C2',
		trainingText: '#fff',
		brand: '#FF6B08',
		transparent: 'transparent',
		backdrop: 'rgba(43, 43, 43, 0.1)',
		counter: '#091E3F',
		icon: 'gold',
		error: '#F25137',
		grafic: '#ffffff',
	},
	shadow: {
		modal: '10px 10px 20px rgba(9, 30, 63, 0.2)',
		box: '0px 2px 3px rgba(9, 30, 63, 0.1)',
		counter: ' 4px 4px 8px rgba(36, 42, 55, 0.15);',
	},
	transition: 'all 250ms cubic-bezier(0.4, 0, 0.2, 1)',
};
export const themeDark = {
	colors: {
		white: '#12151a',
		borderNav: '#1c2432',
		googleBtn: '#1c2432',
		body: '#161c26',
		textMain: '#ffffff',
		textSecondary: '#B1B5C2',
		black: '#ffffffc0',
		icons: '#ececec',
		bookIcons: '#FF6B08',

		myTrainingBox: '#12151a',
		trainingText: '#fff',
		brand: '#FF6B08',
		transparent: 'transparent',
		backdrop: 'rgba(43, 43, 43, 0.1)',
		counter: '#F5F7FA',
		icon: '#E0E5EB',
		grafic: '#1c2432',
	},
	shadow: {
		modal: '10px 10px 20px rgba(9, 30, 63, 0.2)',
		box: '0px 2px 3px rgba(9, 30, 63, 0.1)',
		counter: ' 4px 4px 8px rgba(36, 42, 55, 0.15);',
	},
	transition: 'all 250ms cubic-bezier(0.4, 0, 0.2, 1)',
};
